module.exports = __webpack_public_path__ + "img/jpBanner3.77893e49.png";